import { createSlice } from "@reduxjs/toolkit";

const initialState = {
  currentPage: 1,
  currentFilter: "all",
  currentPageSize: 20,
  sortBy: "",
  sortOrder: "",
  search: "",
  showAddBillToMappingModal: false,
  showDeleteModal: false,
  showFilter: false,
  clearSelection: false,
  selectedBillToMapping: "",
  isEdit: false,
  billToMappingData: [],
  filter: {
    supplier: [],
    shop: [],
    bill_to: [],
  },
};

const billToMappingSlice = createSlice({
  name: "billToMapping",
  initialState,
  reducers: {
    updateConfig: (state, action) => {
      action.payload(state);
    },
  },
});

export const { updateConfig } = billToMappingSlice.actions;

export default billToMappingSlice.reducer;
